<template>
  <div v-if="fonts" class="font-display">
    <p :style="{'font-family': fonts.title }" class="title is-3">{{ fonts.title }}</p>
    <p :style="{'font-family': fonts.paragraph }" class="subtitle is-4">{{ fonts.paragraph }}</p>
  </div>
</template>

<script>
export default {
  name: 'FontDisplay',
  props: ['fonts']
}
</script>

<style lang="scss" scoped>
@import "~~/assets/css/components";

$color-border-radius: 6px;
$border-width: 3px;

.font-display {
  width: 100%;
  height: 100%;
  user-select: none;
  text-align: left;
  padding: 0 5px;

  p {
    &.title {
      font-size: 1.2em;
      margin-bottom: 1.2em;
    }
    &.subtitle {
      font-size: .9em;
    }
  }
}
</style>
